import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SigaSeuPlanoService } from "../services/siga-seu-plano.service";
import { CommonModule } from "@angular/common";
import { DatePipe } from "@angular/common";
import { ModalSigaSeuPlanoComponent } from "../templates/modal-siga-seu-plano/modal-siga-seu-plano.component";

declare var $: any;

@Component({
    selector: "app-siga-seu-plano",
    templateUrl: "./siga-seu-plano.component.html",
    styleUrls: ["./siga-seu-plano.component.css"],
    imports: [CommonModule, DatePipe, ModalSigaSeuPlanoComponent]
})
export class SigaSeuPlanoComponent implements OnInit {
  codAviTipo: string = "0|S";
  filtroMural: string = "N";
  avisos: any[] = [];
  numPagina: number = 1;
  numAviPagina: number = 10;
  temMais: boolean = false;

  itemSel: any;

  constructor(
    private sigaSeuPlanoService: SigaSeuPlanoService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.avisos = [];

      this.listarAvisos();
    });
  }

  ngOnInit() {}

  listarAvisos() {
    this.sigaSeuPlanoService
      .ListarHistorico(
        this.numAviPagina,
        this.numPagina
      )
      .subscribe((res: any[]) => {
        res.forEach((item) => {
          this.avisos.push(item);
        });

        if (res.length >= this.numAviPagina) {
          this.temMais = true;
        } else {
          this.temMais = false;
        }
      });
  }

  onTipoChange() {
    this.avisos = [];
    this.numPagina = 1;
    this.listarAvisos();
  }

  carregarMais() {
    this.numPagina++;
    this.listarAvisos();
  }

  openModalAViso(item: any) {
    this.itemSel = item;
    $("#modalSigaSeuPlanoNot").modal("show");
  }

  onCloseModalAviso() {
    this.itemSel.DEC_ESCONDER = "S";
  }
}
